import { AlertType } from '../../enums';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alertType',
  standalone: false
})
export class AlertTypePipe implements PipeTransform {
  public transform(value: AlertType): string {
    return getAlertType(value);
  }
}

export function getAlertType(value: AlertType): string {
  switch (value) {
    case AlertType.LowAverageRating:
      return 'Low Average Rating';
    case AlertType.SpecificRating:
      return 'Specific Rating';
    case AlertType.LateForm:
      return 'Late Form';
    case AlertType.TrainingTime:
      return 'Training Time';
    case AlertType.PercentageRating:
      return 'Percentage Rating';
    case AlertType.PhaseLength:
      return 'Phase Length';
    case AlertType.PhaseAdditionalHours:
      return 'Phase Additional Hours';
    case AlertType.LateQuiz:
      return 'Late Quiz';
    case AlertType.IncidentWarning:
      return 'Incident Warning';
    case AlertType.NRT:
      return 'Not Responding to Training ';
    case AlertType.UpcomingForm:
      return 'Upcoming Form';
    default:
      throw new Error(`Unsupported value for AlertType: ${value}.`);
  }
}

export function getAlertTypeList(): IdName[] {
  return enumToList(AlertType, getAlertType);
}
